import { handleActions } from 'redux-actions';
import {
    changeThemeToDark,
    changeThemeToLight,
    setPriceHistoryRange,
    setRatingHistoryRange
} from '../actions/themeActions';

const defaultState = {
  className: 'theme-dark',
    priceHistoryRange:14,
    ratingHistoryRange:14
};

export default handleActions(
  {
    [changeThemeToDark]() {
      return { className: 'theme-dark' };
    },
    [changeThemeToLight]() {
      return { className: 'theme-light' };
    },
    [setPriceHistoryRange](state, { payload }) {
      return { ...state, priceHistoryRange: payload };
    },
    [setRatingHistoryRange](state, { payload }) {
        return { ...state, ratingHistoryRange: payload };
    },
  },
  defaultState,
);
